import { CoreBlocks } from '@faustwp/blocks';
import { gql } from '@apollo/client';

const { CoreButton: FaustCoreButton } = CoreBlocks;

export function CoreButton(props) {
  return <FaustCoreButton {...props} />;
}

CoreButton.config = {
  ...FaustCoreButton.config,
  name: `CustomCoreButtonFragment`,
};

CoreButton.fragments = {
  key: `CustomCoreButtonFragment`,
  entry: gql`
    fragment CustomCoreButtonFragment on CoreButton {
      attributes {
        anchor
        backgroundColor
        cssClassName
        fontFamily
        fontSize
        gradient
        linkClassName
        linkTarget
        rel
        style
        text
        textColor
        url
      }
    }
  `,
};
